import {appAPI} from "../../../api";
import {GENERAL, IChatAttachment, IChatMessage, IReactionsEvent, IThread, MESSAGES_PAGE} from "../model/types";

/** Курсор «старше чем»: время и id первого загруженного сообщения. */
export interface IChatCursor {
    before: string;
    before_id: string;
}

/**
 * HTTP чата (src/chat/chat.controller.ts). Ошибки не перехватываются: текст
 * берётся из `message` ответа в thunk'ах.
 */
export const chatAPI = {
    getMessages: async (channel: string, cursor?: IChatCursor): Promise<IChatMessage[]> => {
        const where = channel === GENERAL ? {channel: GENERAL} : {car_id: channel};
        return (await appAPI.get("/chat/messages", {params: {...where, ...cursor, limit: MESSAGES_PAGE}})).data;
    },
    uploadAttachment: async (
        file: Blob,
        name: string,
        opts: {thumb?: Blob | null; width?: number; height?: number; onProgress?: (part: number) => void},
    ): Promise<IChatAttachment> => {
        const form = new FormData();
        form.append("file", file, name);
        if (opts.thumb) form.append("thumb", opts.thumb, opts.thumb.type === "image/png" ? "thumb.png" : "thumb.jpg");
        if (opts.width) form.append("width", String(opts.width));
        if (opts.height) form.append("height", String(opts.height));
        const res = await appAPI.post("/chat/attachments", form, {
            headers: {"Content-Type": "multipart/form-data"},
            onUploadProgress: (e) => {
                if (opts.onProgress && e.total) opts.onProgress(e.loaded / e.total);
            },
        });
        return res.data;
    },
    send: async (channel: string, text: string, attachment_ids: string[]): Promise<IChatMessage> =>
        (await appAPI.post("/chat/messages", {car_id: channel === GENERAL ? undefined : channel, text, attachment_ids})).data,
    edit: async (id: string, text: string): Promise<IChatMessage> =>
        (await appAPI.patch(`/chat/messages/${id}`, {text})).data,
    remove: async (id: string): Promise<{id: string; car_id: string | null}> =>
        (await appAPI.delete(`/chat/messages/${id}`)).data,
    addReaction: async (id: string, emoji: string): Promise<IReactionsEvent> =>
        (await appAPI.post(`/chat/messages/${id}/reactions`, {emoji})).data,
    removeReaction: async (id: string, emoji: string): Promise<IReactionsEvent> =>
        (await appAPI.delete(`/chat/messages/${id}/reactions`, {data: {emoji}})).data,
    read: async (channel: string): Promise<void> => {
        await appAPI.post("/chat/read", {channel});
    },
    unread: async (): Promise<Record<string, number>> => (await appAPI.get("/chat/unread")).data,
    /** Треды машин для «Обсуждений», свежие сверху (S11). */
    threads: async (): Promise<IThread[]> => (await appAPI.get("/chat/threads")).data,
};
